import type { PostLoginTranslations } from './types';

export const dashboardTranslations = {
  'dashboard.nav.home': { es: 'Dashboard', en: 'Dashboard' },
  'dashboard.nav.menu': { es: 'Menú', en: 'Menu' },
  'dashboard.nav.openMenu': { es: 'Abrir menú', en: 'Open menu' },
  'dashboard.nav.mainMenu': { es: 'Menú principal', en: 'Main menu' },
  'dashboard.nav.personalSpace': { es: 'Tu espacio personal', en: 'Your personal space' },
  'dashboard.nav.closeMenu': { es: 'Cerrar menú', en: 'Close menu' },
  'dashboard.section.missions.title': { es: 'Misiones', en: 'Missions' },
  'dashboard.section.missions.subtitle': { es: 'Tus misiones activas', en: 'Your active missions' },
  'dashboard.section.missions.description': {
    es: 'Accedé rápidamente a misiones diarias, semanales y eventos especiales.',
    en: 'Quickly access daily missions, weekly goals, and special events.',
  },
  'dashboard.section.rewards.title': { es: 'Logros', en: 'Achievements' },
  'dashboard.section.rewards.subtitle': { es: 'Estantes de Logros', en: 'Achievement Shelves' },
  'dashboard.section.rewards.description': {
    es: 'Revisá tus hitos en Logros y seguí avanzando hacia tu próximo objetivo.',
    en: 'Review your milestones in Achievements and keep moving toward your next goal.',
  },
  'dashboard.quickAccess.title': { es: 'Guía para añadir acceso rápido', en: 'Quick access setup guide' },
  'dashboard.quickAccess.subtitle': { es: 'Sigue los siguientes pasos:', en: 'Follow these steps:' },
  'dashboard.quickAccess.tap': { es: 'Tocar', en: 'Tap' },
  'dashboard.quickAccess.scrollUp': { es: 'Scrollear para arriba', en: 'Scroll up' },
  'dashboard.quickAccess.select': { es: 'Seleccionar', en: 'Select' },
  'dashboard.quickAccess.stepAdd': { es: 'Añadir.', en: 'Add.' },
  'dashboard.quickAccess.gotIt': { es: 'Entedido', en: 'Understood' },
  'dashboard.theme.appearance': { es: 'Apariencia', en: 'Appearance' },
  'dashboard.theme.light': { es: 'Claro', en: 'Light' },
  'dashboard.theme.dark': { es: 'Oscuro', en: 'Dark' },
  'dashboard.theme.auto': { es: 'Auto', en: 'Auto' },
  'dashboard.language.title': { es: 'Idioma', en: 'Language' },
  'dashboard.language.spanish': { es: 'Español', en: 'Español' },
  'dashboard.language.english': { es: 'English', en: 'English' },
  'dashboard.language.selected': { es: 'Seleccionado', en: 'Selected' },
  'dashboard.action.edit': { es: 'Editar', en: 'Edit' },
  'dashboard.moderation.sugarHint': { es: 'Azúcar: seguimiento de azúcar añadido.', en: 'Sugar: added sugar tracking.' },
  'dashboard.moderation.tipLongPress': { es: 'Tip: mantené presionado un widget para editarlo.', en: 'Tip: long-press a widget to edit it.' },
  'dashboard.moderation.active': { es: 'Activo', en: 'Active' },

  'dashboard.menu.avatarAlt': { es: 'Avatar', en: 'Avatar' },
  'dashboard.menu.profileFallback': { es: 'Tu perfil', en: 'Your profile' },
  'dashboard.menu.moderationSaveError': {
    es: 'No se pudo guardar Moderación. Revisa tu conexión e inténtalo otra vez.',
    en: 'Could not save Moderation. Check your connection and try again.',
  },
  'dashboard.menu.reminder': { es: 'Recordatorio', en: 'Reminder' },
  'dashboard.menu.gameMode': { es: 'Ritmo', en: 'Rhythm' },
  'dashboard.menu.changeGameMode': { es: 'Cambiar ritmo', en: 'Change rhythm' },
  'dashboard.menu.changeAvatar': { es: 'Cambiar avatar', en: 'Change Avatar' },
  'dashboard.menu.upgradeAvailable': { es: 'Ritmo recomendado', en: 'Recommended rhythm' },
  'dashboard.menu.chooseGameMode': { es: 'Elegí tu ritmo', en: 'Choose your rhythm' },
  'dashboard.menu.gameModeDemandingWarning': {
    es: 'This will make your task tracking significantly more demanding.',
    en: 'This will make your task tracking significantly more demanding.',
  },
  'dashboard.menu.confirmChange': { es: 'Confirmar cambio', en: 'Confirm change' },
  'dashboard.menu.weeklyIntensity': { es: 'Intensidad semanal', en: 'Weekly intensity' },
  'dashboard.menu.currentGameMode': { es: 'Modo actual', en: 'Current mode' },
  'dashboard.menu.currentRhythm': { es: 'Ritmo actual', en: 'Current rhythm' },
  'dashboard.menu.currentAvatar': { es: 'Avatar actual', en: 'Current avatar' },
  'dashboard.menu.gameModeConfirmPrompt': { es: '¿Confirmas cambiar tu ritmo a {{mode}}?', en: 'Do you want to change your rhythm to {{mode}}?' },
  'dashboard.menu.avatarConfirmPrompt': { es: '¿Confirmas cambiar tu avatar?', en: 'Do you want to change your avatar?' },
  'dashboard.menu.gameModeSaving': { es: 'Guardando…', en: 'Saving…' },
  'dashboard.menu.avatarSaving': { es: 'Guardando…', en: 'Saving…' },
  'dashboard.menu.gameModeUpdated': { es: 'Ritmo actualizado.', en: 'Rhythm updated.' },
  'dashboard.menu.avatarUpdated': { es: 'Avatar actualizado.', en: 'Avatar updated.' },
  'dashboard.menu.gameModeSaveError': {
    es: 'No se pudo cambiar el ritmo. Revisá tu conexión e intentá de nuevo.',
    en: 'Could not change rhythm. Check your connection and try again.',
  },
  'dashboard.menu.avatarSaveError': {
    es: 'No se pudo cambiar el avatar. Revisá tu conexión e intentá de nuevo.',
    en: 'Could not change avatar. Check your connection and try again.',
  },
  'dashboard.menu.cancel': { es: 'Cancelar', en: 'Cancel' },
  'dashboard.menu.plans': { es: 'Planes', en: 'Plans' },
  'dashboard.menu.subscription': { es: 'Suscripción', en: 'Subscription' },
  'dashboard.menu.widgets': { es: 'Widgets', en: 'Widgets' },
  'dashboard.menu.activeWidgets': { es: 'Widgets activos', en: 'Active widgets' },
  'dashboard.menu.noActiveWidgets': { es: 'Sin widgets activos.', en: 'No active widgets.' },
  'dashboard.menu.availableWidgets': { es: 'Widgets disponibles', en: 'Available widgets' },
  'dashboard.menu.configured': { es: 'Configurado', en: 'Configured' },
  'dashboard.menu.backToMenu': { es: 'Volver al menú', en: 'Back to menu' },
  'dashboard.menu.moderation': { es: 'Moderación', en: 'Moderation' },
  'dashboard.menu.moderationSubtitle': { es: 'Alcohol, tabaco y azúcar', en: 'Alcohol, tobacco and sugar' },
  'dashboard.menu.sugarAdded': { es: 'Azúcar añadido', en: 'Added sugar' },
  'dashboard.menu.quickAccess': { es: 'Acceso rápido', en: 'Quick access' },
  'dashboard.menu.quickAccessActive': { es: 'Acceso rápido activo', en: 'Quick access active' },
  'dashboard.menu.quickAccessAdd': { es: 'Añadir acceso rápido', en: 'Add quick access' },
  'dashboard.menu.signOut': { es: 'Cerrar sesión', en: 'Sign out' },
  'dashboard.menu.deleteAccount': { es: 'Eliminar cuenta', en: 'Delete account' },
  'dashboard.menu.deleteAccountEyebrow': { es: 'Acción irreversible', en: 'Irreversible action' },
  'dashboard.menu.deleteAccountTitle': { es: 'Eliminar cuenta', en: 'Delete account' },
  'dashboard.menu.deleteAccountBody': {
    es: 'Esta acción elimina tu cuenta de forma permanente. No vas a poder recuperar tu perfil ni tu progreso después de confirmar.',
    en: 'This permanently deletes your account. You will not be able to recover your profile or progress after confirming.',
  },
  'dashboard.menu.deleteAccountConfirmLabel': {
    es: 'Escribí {{keyword}} para confirmar',
    en: 'Type {{keyword}} to confirm',
  },
  'dashboard.menu.deleteAccountConfirm': { es: 'Eliminar definitivamente', en: 'Delete permanently' },
  'dashboard.menu.deleteAccountDeleting': { es: 'Eliminando…', en: 'Deleting…' },
  'dashboard.menu.deleteAccountError': {
    es: 'No se pudo eliminar la cuenta. Revisá tu conexión e intentá otra vez.',
    en: 'Could not delete the account. Check your connection and try again.',
  },
  'dashboard.upgradeCta.closeAria': { es: 'Cerrar recomendación de ritmo', en: 'Close rhythm recommendation' },
  'dashboard.upgradeCta.bannerTitle': { es: 'Tu ritmo puede subir de intensidad', en: 'Your rhythm can increase in intensity' },
  'dashboard.upgradeCta.bannerBody': {
    es: 'Según tu progreso, podés pasar de {{currentMode}} a {{nextMode}} para sostener más frecuencia semanal.',
    en: 'Based on your progress, you can move from {{currentMode}} to {{nextMode}} to hold a higher weekly frequency.',
  },
  'dashboard.upgradeCta.bannerAction': { es: 'Continuar', en: 'Continue' },
  'dashboard.upgradeCta.modalEyebrow': { es: 'RECOMENDACIÓN DE RITMO', en: 'RHYTHM RECOMMENDATION' },
  'dashboard.upgradeCta.modalTitle': {
    es: 'Ajustá tu ritmo de {{currentMode}} a {{nextMode}}',
    en: 'Adjust your rhythm from {{currentMode}} to {{nextMode}}',
  },
  'dashboard.upgradeCta.modalBody': {
    es: 'Tu progreso indica que ya podés sostener esta intensidad. Si confirmás, tu Journey pasa a evaluarse con el nuevo ritmo.',
    en: 'Your progress shows you can sustain this intensity. If you confirm, your journey will be evaluated with the new rhythm.',
  },
  'dashboard.upgradeCta.nowTag': { es: 'AHORA', en: 'NOW' },
  'dashboard.upgradeCta.nextTag': { es: 'SIGUIENTE', en: 'NEXT' },
  'dashboard.upgradeCta.dragHint': {
    es: 'Deslizá para confirmar el cambio de ritmo',
    en: 'Slide to confirm your rhythm change',
  },
  'dashboard.upgradeCta.viewAllModes': { es: 'Ver todos los ritmos', en: 'View all rhythms' },
  'dashboard.upgradeCta.success': { es: 'Nuevo ritmo activado: {{nextMode}}', en: 'New rhythm activated: {{nextMode}}' },
  'dashboard.upgradeCta.successSubtitle': { es: 'Tu intensidad semanal ya se actualizó.', en: 'Your weekly intensity has been updated.' },
  'dashboard.upgradeCta.welcomeToast': {
    es: 'Te damos la bienvenida a tu nuevo ritmo {{nextMode}}',
    en: 'Welcome to your new {{nextMode}} rhythm',
  },
  'dashboard.upgradeCta.finalAction': { es: 'Seguir con mi Journey', en: 'Continue my journey' },
  'dashboard.upgradeCta.close': { es: 'Cerrar', en: 'Close' },
  'dashboard.upgradeCta.updating': { es: 'Actualizando...', en: 'Updating...' },
  'dashboard.quickAccess.iosDialogAria': { es: 'Cómo añadir acceso rápido en iOS', en: 'How to add quick access on iOS' },
  'dashboard.reminderScheduler.eyebrow': { es: 'Scheduler diario', en: 'Daily scheduler' },
  'dashboard.reminderScheduler.title': { es: 'Recordatorios inteligentes', en: 'Smart reminders' },
  'dashboard.reminderScheduler.description': {
    es: 'Configurá tu recordatorio por correo o pausa cuando lo necesites.',
    en: 'Set your email reminder or pause it whenever you need.',
  },
  'dashboard.reminderScheduler.closeAria': { es: 'Cerrar recordatorio diario', en: 'Close daily reminder' },
  'dashboard.moderation.editSheetAria': { es: 'Editar moderación', en: 'Edit moderation' },
  'dashboard.moderation.editSheetTitle': { es: 'Editar moderación', en: 'Edit moderation' },
  'dashboard.moderation.close': { es: 'Cerrar', en: 'Close' },
  'dashboard.moderation.loadingConfig': { es: 'Cargando configuración…', en: 'Loading settings…' },
  'dashboard.moderation.disabled': { es: 'Desactivado', en: 'Disabled' },
  'dashboard.moderation.vacation': { es: 'Vacaciones', en: 'Vacation mode' },
  'dashboard.moderation.toleranceLabel': { es: 'Tolerancia sin marcar: {{days}}', en: 'Unchecked tolerance: {{days}}' },
  'dashboard.journeyReady.title': { es: 'Tu Journey está listo', en: 'Your journey is ready' },
  'dashboard.journeyReady.subtitle': {
    es: 'Tus primeras tareas ya están creadas. Revisalas y ajustalas a tu rutina.',
    en: 'Your first tasks are already created. Review and adjust them to your routine.',
  },
  'dashboard.journeyReady.viewTasks': { es: 'Ver tareas creadas ({{count}})', en: 'View created tasks ({{count}})' },
  'dashboard.journeyReady.moreTasks': { es: '+{{count}} más', en: '+{{count}} more' },
  'dashboard.journeyReady.viewAll': { es: 'Ver todas', en: 'View all' },
  'dashboard.journeyReady.firstStep': { es: 'Primer paso recomendado', en: 'Recommended first step' },
  'dashboard.journeyReady.firstStepHelp': {
    es: 'Editá tu base para asegurarte de que las tareas encajen con tu energía real.',
    en: 'Edit your base to make sure tasks fit your real energy.',
  },
  'dashboard.journeyReady.goDashboard': { es: 'Ir al Dashboard', en: 'Go to Dashboard' },
  'dashboard.journeyReady.editBaseTasks': { es: 'Editar tareas', en: 'Edit tasks' },
  'dashboard.streakTaskInsights.weeklyProgressAria': { es: 'Progreso semanal: {{progress}}%', en: 'Weekly progress: {{progress}}%' },
  'dashboard.streakTaskInsights.dialogAria': { es: 'Detalle de tarea', en: 'Task details' },
  'dashboard.streakTaskInsights.title': { es: 'Detalle de tarea', en: 'Task details' },
  'dashboard.streakTaskInsights.taskFallback': { es: 'Tarea', en: 'Task' },
  'dashboard.streakTaskInsights.closeAria': { es: 'Cerrar detalle', en: 'Close details' },
  'dashboard.streakTaskInsights.activity': { es: 'Actividad', en: 'Activity' },
  'dashboard.streakTaskInsights.weeklyProgress': { es: 'Progreso semanal', en: 'Weekly progress' },
  'dashboard.streakTaskInsights.goal': { es: 'Objetivo: {{goal}}x/sem', en: 'Goal: {{goal}}x/week' },
  'dashboard.streakTaskInsights.currentStreak': { es: 'Racha actual', en: 'Current streak' },
  'dashboard.streakTaskInsights.bestStreak': { es: 'Mejor racha', en: 'Best streak' },
  'dashboard.streakTaskInsights.achievementSeal': { es: '🏅 Logrado', en: '🏅 Achieved' },
  'dashboard.streakTaskInsights.activity.empty.week': { es: 'Sin registros en esta semana.', en: 'No activity records this week.' },
  'dashboard.streakTaskInsights.activity.empty.month': { es: 'Sin registros en este mes.', en: 'No activity records this month.' },
  'dashboard.streakTaskInsights.activity.empty.quarter': { es: 'Sin registros en los últimos 3 meses.', en: 'No activity records in the last 3 months.' },
  'dashboard.streakTaskInsights.activity.caption.week': { es: 'Actividad diaria de la semana en curso.', en: 'Daily activity for the current week.' },
  'dashboard.streakTaskInsights.activity.caption.month': {
    es: 'Actividad diaria del mes (scroll horizontal para ver todos los días).',
    en: 'Daily activity for the month (horizontal scroll to view every day).',
  },
  'dashboard.streakTaskInsights.activity.caption.quarter': {
    es: 'Semanas de los últimos 3 meses (verde = objetivo cumplido).',
    en: 'Weeks from the last 3 months (green = goal achieved).',
  },
  'dashboard.streakTaskInsights.weeklyProgress.empty': {
    es: 'Aún no registramos semanas para esta tarea.',
    en: 'No weekly records yet for this task.',
  },
  'dashboard.streakTaskInsights.weeklyProgress.goalReached': {
    es: 'Meta cumplida {{completed}} de {{total}} semanas.',
    en: 'Goal reached in {{completed}} out of {{total}} weeks.',
  },
  'dashboard.streakTaskInsights.weeklyProgress.error': {
    es: 'No pudimos cargar la serie semanal: {{message}}',
    en: 'Could not load weekly series: {{message}}',
  },
  'dashboard.streakTaskInsights.habitHealth.strong': { es: 'Hábito fuerte', en: 'Strong habit' },
  'dashboard.streakTaskInsights.habitHealth.medium': { es: 'Hábito en construcción', en: 'Habit in progress' },
  'dashboard.streakTaskInsights.habitHealth.weak': { es: 'Hábito frágil', en: 'Fragile habit' },
  'dashboard.streakTaskInsights.streak.tieRecord': { es: 'Estás empatando tu récord.', en: 'You are tying your record.' },
  'dashboard.streakTaskInsights.streak.oneAway': { es: 'Estás a 1 semana de superar tu récord.', en: 'You are 1 week away from beating your record.' },
  'dashboard.streakTaskInsights.streak.weeksInRow': { es: 'semanas seguidas', en: 'weeks in a row' },
  'dashboard.streakTaskInsights.streak.bestLabel': { es: 'máxima racha lograda', en: 'best streak achieved' },
  'dashboard.streakTaskInsights.recalibration.title': { es: 'Ajustes de dificultad', en: 'Difficulty adjustments' },
  'dashboard.streakTaskInsights.recalibration.latest': { es: 'Último: {{date}}', en: 'Latest: {{date}}' },
  'dashboard.streakTaskInsights.recalibration.empty': { es: 'Aún no hay recalibraciones.', en: 'No recalibrations yet.' },
  'dashboard.streakTaskInsights.recalibration.recentMonth': { es: 'Mes reciente', en: 'Recent month' },
  'dashboard.streakTaskInsights.recalibration.summary': {
    es: '{{completions}}/{{expected}} · {{rate}}%',
    en: '{{completions}}/{{expected}} · {{rate}}%',
  },
  'dashboard.streakTaskInsights.recalibration.reasonFallback': {
    es: 'Sin razón detallada disponible.',
    en: 'No detailed reason available.',
  },
  'dashboard.streakTaskInsights.recalibration.reasonUnknown': {
    es: 'Razón no disponible en tu idioma.',
    en: 'Reason unavailable in your language.',
  },
  'dashboard.streakTaskInsights.recalibration.reason.highCompletion': {
    es: 'La tasa de cumplimiento fue mayor al 80%, el sistema sugirió bajar un nivel de dificultad.',
    en: 'Completion rate was above 80%, so the system suggested decreasing difficulty by one level.',
  },
  'dashboard.streakTaskInsights.recalibration.reason.mediumCompletion': {
    es: 'La tasa de cumplimiento estuvo entre 50% y 79%, por eso la dificultad se mantuvo.',
    en: 'Completion rate was between 50% and 79%, so difficulty was kept.',
  },
  'dashboard.streakTaskInsights.recalibration.reason.lowCompletion': {
    es: 'La tasa de cumplimiento fue menor al 50%, el sistema sugirió subir un nivel de dificultad.',
    en: 'Completion rate was below 50%, so the system suggested increasing difficulty by one level.',
  },
  'dashboard.streakTaskInsights.recalibration.tooltip.latest': {
    es: 'Última recalibración: ↑ subió dificultad, • se mantuvo, ↓ bajó dificultad.',
    en: 'Latest recalibration: ↑ difficulty went up, • stayed the same, ↓ difficulty went down.',
  },
  'dashboard.streakTaskInsights.recalibration.tooltip.empty': {
    es: 'Aún no hay recalibraciones. Se activan cuando hay historial suficiente del período anterior.',
    en: 'No recalibrations yet. They appear once enough prior period history is available.',
  },
  'dashboard.streakTaskInsights.recalibration.action.down': { es: '↓ Disminuyó', en: '↓ Decreased' },
  'dashboard.streakTaskInsights.recalibration.action.keep': { es: '• Se mantuvo', en: '• Kept' },
  'dashboard.streakTaskInsights.recalibration.action.up': { es: '↑ Aumentó', en: '↑ Increased' },
  'dashboard.metricHeader.title': { es: 'Progreso general', en: 'Overall progress' },
  'dashboard.metricHeader.maxLevel': { es: '✨ Alcanzaste el nivel máximo disponible en esta etapa.', en: '✨ You reached the highest level available at this stage.' },
  'dashboard.metricHeader.toNextLevel': { es: '✨ Te faltan {{gp}} para el próximo nivel', en: '✨ You need {{gp}} to reach the next level' },
  'dashboard.metricHeader.loadError': { es: 'No pudimos cargar tu progreso.', en: 'We could not load your progress.' },
  'dashboard.metricHeader.loading': { es: 'Actualizando progreso…', en: 'Updating progress…' },
  'dashboard.metricHeader.infoAria': { es: 'Más información sobre tu progreso general', en: 'More information about your overall progress' },
  'dashboard.metricHeader.serviceError': { es: 'No pudimos conectar con el servicio de GP. Probá actualizar más tarde.', en: 'We could not connect to the GP service. Try refreshing later.' },
  'dashboard.metricHeader.serviceErrorHint': { es: 'Los datos de progreso se recalculan automáticamente cada pocas horas.', en: 'Progress data is recalculated automatically every few hours.' },
  'dashboard.metricHeader.level': { es: 'Nivel', en: 'Level' },
  'dashboard.metricHeader.progress': { es: 'Progreso', en: 'Progress' },
  'dashboard.metricHeader.progressAria': { es: 'Progreso hacia el próximo nivel', en: 'Progress to the next level' },
  'dashboard.metricHeader.progressCompleted': { es: '{{percent}} completado', en: '{{percent}} completed' },
  'dashboard.radar.title': { es: 'EQUILIBRIO', en: 'BALANCE' },
  'dashboard.radar.subtitle': { es: 'Distribución de GP entre pilares', en: 'GP distribution across pillars' },
    'dashboard.radar.loadError': { es: 'No pudimos construir el radar. Probá más tarde.', en: 'We could not build the radar. Try again later.' },
  'dashboard.radar.empty': { es: 'Todavía no registraste GP por rasgo. Completá misiones para ver cómo evoluciona tu radar.', en: 'You have not logged GP by trait yet. Complete missions to see how your radar evolves.' },
  'dashboard.radar.pillars.body': { es: 'Cuerpo', en: 'Body' },
  'dashboard.radar.pillars.mind': { es: 'Mente', en: 'Mind' },
  'dashboard.radar.pillars.soul': { es: 'Alma', en: 'Soul' },
  'dashboard.radar.status.balanced': { es: 'Equilibrado', en: 'Balanced' },
  'dashboard.radar.status.bodyDominant': { es: 'Predominio Body', en: 'Body dominant' },
  'dashboard.radar.status.mindDominant': { es: 'Predominio Mind', en: 'Mind dominant' },
  'dashboard.radar.status.soulDominant': { es: 'Predominio Soul', en: 'Soul dominant' },
  'dashboard.streaks.consecutiveDays': { es: '— días consecutivos sin cortar', en: '— consecutive days without breaks' },
  'dashboard.streaks.allTasks': { es: 'Todas las tareas', en: 'All tasks' },
  'dashboard.streaks.noneHighlighted': { es: 'Todavía no hay rachas destacadas.', en: 'There are no highlighted streaks yet.' },
  'dashboard.streaks.noneForFilter': { es: 'No encontramos tareas activas para este pilar en las últimas semanas.', en: 'We did not find active tasks for this pillar in recent weeks.' },
  'dashboard.streaks.week': { es: 'Sem', en: 'Week' },
  'dashboard.streaks.month': { es: 'Mes', en: 'Month' },
  'dashboard.streaks.daysConsecutiveSr': { es: '{{days}} días consecutivos', en: '{{days}} consecutive days' },
  'dashboard.moderation.tobacco': { es: 'Tabaco', en: 'Tobacco' },
  'dashboard.moderation.sugar': { es: 'Azúcar', en: 'Sugar' },
  'dashboard.dailyCultivation.subtitle': { es: 'Tendencia mensual de GP', en: 'Monthly GP trend' },
  'dashboard.dailyCultivation.month': { es: 'Mes', en: 'Month' },
  'dashboard.dailyCultivation.error': { es: 'No pudimos cargar tus GP diarios.', en: 'We could not load your daily GP.' },
  'dashboard.dailyCultivation.empty': { es: 'Todavía no registraste GP este mes.', en: 'You have not logged GP this month yet.' },
  'dashboard.dailyCultivation.total': { es: 'Total GP del mes', en: 'Total monthly GP' },
  'dashboard.dailyCultivation.average': { es: 'Promedio diario', en: 'Daily average' },
  'dashboard.rewards.subtitle': {
    es: 'Seguimiento de logros, badges y Logros desbloqueados',
    en: 'Track achievements, badges, and unlocked Achievements',
  },
  'dashboard.rewards.update': { es: 'Actualizar', en: 'Update' },
  'dashboard.rewards.loadError': { es: 'No pudimos cargar tus Logros.', en: 'We could not load your Achievements.' },
  'dashboard.rewards.retry': { es: 'Reintentar', en: 'Retry' },
  'dashboard.rewards.completed': { es: 'Completados', en: 'Completed' },
  'dashboard.rewards.inProgress': { es: 'En progreso', en: 'In progress' },
  'dashboard.rewards.emptyTitle': { es: 'Todavía no desbloqueaste Logros.', en: 'You have not unlocked Achievements yet.' },
  'dashboard.rewards.emptyDescription': {
    es: 'Completá misiones y mantené tus streaks activos para sumar GP y alcanzar nuevos hitos.',
    en: 'Complete missions and keep your streaks active to earn GP and reach new milestones.',
  },
  'dashboard.rewards.currentWeek': { es: 'Semana en curso', en: 'Current week' },
  'dashboard.rewards.latestWeek': { es: 'Semana más reciente', en: 'Most recent week' },
  'dashboard.rewards.previousWeek': { es: 'Semana anterior', en: 'Previous week' },
  'dashboard.rewards.unlocked': { es: 'Desbloqueado', en: 'Unlocked' },
  'dashboard.rewards.reachedOn': { es: 'Alcanzado el {{date}}', en: 'Reached on {{date}}' },
  'dashboard.rewards.newUnlocked': { es: 'Nuevo logro desbloqueado', en: 'New achievement unlocked' },
  'dashboard.rewards.progressCompleted': { es: '{{current}} / {{target}} completado', en: '{{current}} / {{target}} completed' },
  'dashboard.emotionChart.lastSixMonths': { es: 'Últimos 6 meses', en: 'Last 6 months' },
  'dashboard.emotionChart.loadError': { es: 'Todavía no pudimos cargar tus emociones.', en: 'We could not load your emotions yet.' },
  'dashboard.emotionChart.empty': { es: 'Registrá tu primera emoción para ver el mapa de calor.', en: 'Log your first emotion to view the heatmap.' },
  'dashboard.emotionChart.period': { es: 'Período analizado', en: 'Analyzed period' },
  'dashboard.emotionChart.record.single': { es: 'registro', en: 'record' },
  'dashboard.emotionChart.record.plural': { es: 'registros', en: 'records' },
  'dashboard.emotionChart.mostFrequent': {
    es: 'Emoción más frecuente en los últimos {{days}} días ({{count}} {{registerLabel}})',
    en: 'Most frequent emotion in the last {{days}} days ({{count}} {{registerLabel}})',
  },
  'dashboard.emotionChart.insufficientData': {
    es: 'Aún no hay suficiente información reciente para destacar una emoción.',
    en: 'There is not enough recent information yet to highlight an emotion.',
  },
} satisfies PostLoginTranslations;
